"use strict";

var RovingTabindex = _interopRequireWildcard(require("makeup-roving-tabindex"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// REQUIRE
//const RovingTabindex = require('makeup-roving-tabindex');

// IMPORT

const rovers = [];
const appender = document.getElementById("appender");
const prepender = document.getElementById("prepender");
const removeFirst = document.getElementById("removeFirst");
const removeLast = document.getElementById("removeLast");
const widgetEls = document.querySelectorAll(".widget");
const wrap = document.getElementById("wrap");
const log = e => console.log(e.type, e.detail);
appender.addEventListener("click", function () {
  widgetEls.forEach(function (el) {
    const listItem = document.createElement("li");
    listItem.innerText = `Item ${parseInt(el.querySelectorAll("li").length + 1, 10)}`;
    el.children[0].appendChild(listItem);
  });
});
prepender.addEventListener("click", function () {
  widgetEls.forEach(function (el) {
    const ul = el.children[0];
    const listItem = document.createElement("li");
    listItem.innerText = `Item ${parseInt(el.querySelectorAll("li").length + 1, 10)}`;
    ul.insertBefore(listItem, ul.children[0]);
  });
});
removeFirst.addEventListener("click", function () {
  widgetEls.forEach(function (el) {
    const ul = el.children[0];
    const node = ul.firstElementChild;
    if (node) ul.removeChild(node);
  });
});
removeLast.addEventListener("click", function () {
  widgetEls.forEach(function (el) {
    const ul = el.children[0];
    const node = ul.lastElementChild;
    if (node) ul.removeChild(node);
  });
});
removeCurrent.addEventListener("click", () => rovers.forEach(widget => widget.currentItem.remove()));
disableCurrent.addEventListener("click", () => rovers.forEach(widget => widget.currentItem.setAttribute("aria-disabled", "true")));
hideCurrent.addEventListener("click", () => rovers.forEach(widget => widget.currentItem.hidden = true));
wrap.addEventListener("change", e => rovers.forEach(rover => rover.wrap = e.target.checked));
widgetEls.forEach(function (el) {
  el.addEventListener("rovingTabindexInit", log);
  el.addEventListener("rovingTabindexChange", log);
  el.addEventListener("rovingTabindexMutation", log);
  el.addEventListener("rovingTabindexReset", log);
  rovers.push(RovingTabindex.createLinear(el, "li"));
});